import React from 'react';

import { Button, Icon} from 'antd';

const Submit = ({children, icon, disabled, onClickHandle}) => (
    <Button disabled={disabled} icon={icon || ''} className="extends-button" onClick={() => {onClickHandle()}}>{children}</Button>
);

export default Submit;